import { StrictMode, useContext, useState } from 'react'
import '../../style/components/editBox.css'
import { context } from '../../context/context'
import LoginForm from '../loginPage/LoginForm';
import { action } from '../../context/action';
import { switchh } from '../../context/switch';
import { useTranslation } from 'react-i18next';
import { CalcDiscount } from '../../funcs/calcDiscount';

export default function EditBox (props) {
    const { t } = useTranslation();
    const { setErrorMessage, errorMessage } = useContext(action);
    const {setEnableDiscount, enableDiscount} = useContext(switchh);
    
    const {setEdit, cart,  discount, setDiscount, setCart} = useContext(context);
    
    const [editQuntity, setEditQuntity] = useState("");
    const [giveDiscount,setGiveDiscount] = useState(false);
    
    
    const data = props.data || {}
    
    const Reset = () => {
        setEdit([]); 
        setErrorMessage("");
        setGiveDiscount(false);
    }

    // if change quantity
    const editItem = (e) => {
        e.preventDefault();
        const quantaty = parseInt(editQuntity);
        if(quantaty <= 0 || isNaN(quantaty)) {
            setErrorMessage("please enter quantity value valid");
            return;
        }
        const newAmount = CalcDiscount(data.discount, quantaty, data.price).result;
        
        const update = {
            ...data,
            quantity: quantaty,
            amount: newAmount
        }
        const index = cart.findIndex(product => product.id === update.id);
        if (index === -1) return;

        const updatedCart = [...cart];
        updatedCart[index] = update;

        setCart(updatedCart);

        Reset();
    }
    const DiscountProduct = (e) => {
        e.preventDefault();
        const dis = Number(discount);

        // if (dis === 0 || dis > Number(props.total)) {
        //     setErrorMessage("the discount invalid");
        // } else {
        //     setErrorMessage("");

        //     let giveDis = cart.find((e) => e.id === props.id);
        //     giveDis.discount = dis;

        //     const newTotal = (giveDis.price * giveDis.quantity) - dis;
        //     giveDis.total = newTotal.toFixed(2);

        //     Reset();
        // }
    };


    return (
        <div className="container-box edit-container fixed flex flex-center-center">
            <div className="edit-box box">
                <button onClick={() => Reset()} className='close'>x</button>
                <div className='hidden'>{data.id}</div>
                <h3>{t("common:title")}: {data.name}</h3>
                <p>{t("common:quantity")}: {data.quantity}</p>
                <p>{t("common:pos.total")}: {data.amount} {props.currency}</p>
            <hr/>
                <div className='form'>
                    {giveDiscount || data.measure !== 'unit' ? 
                    <>
                        <h3>صلاحية المدير</h3>
                        <p>يرجى ادخال الرقم السري الخاص بالمدير</p>
                        <LoginForm mode="authorization" />
                    </>
                    :    
                    enableDiscount ?           
                    <div>
                        <form onSubmit={DiscountProduct}>
                            <label>discount</label>
                            <input  
                            onChange={(e) => setDiscount(e.target.value)}
                            value={discount}
                            autoFocus type='text' placeholder='give your discount'/>
                            <p className='error'>{errorMessage}</p>
                            <div className='actionBtns flex'>
                                <button>add discount</button>
                            </div>
                        </form>
                    </div>
                    :
                    <div>
                        <form onSubmit={editItem}>
                            <label>{t("common:quantity")}</label>
                            <input  
                            onChange={(e) => setEditQuntity(e.target.value)}
                            value={editQuntity}
                            autoFocus type='text' placeholder='write new quantity'/>
                            <p className='error'>{errorMessage}</p>
                            <div className='actionBtns flex'>
                                <button type='submit' className='btn'>{t("action:edit")}</button>
                                <button type='button' onClick={()=>setGiveDiscount(true)}>{t("action:add")} {t("common:pos.discount")}</button>
                            </div>
                        </form>
                    </div>
                    }
                </div>
            </div>
        </div>
    )
}